import * as React from 'react'

import { IPermitTypeField } from '~/client/graph/types.generated'
import PermitFieldIcon from '~/client/src/shared/components/PermitFieldIcon/PermitFieldIcon'

interface IProps {
  caption: string
  field: IPermitTypeField

  isIconShown?: boolean
}

export default function RuleValueTag({ caption, field, isIconShown }: IProps) {
  return (
    <div className="my2 tw:flex tw:items-center tw:gap-[5px] no-flex h20 max-width250 conditional-field-tag ba-palette-brand-lighter brada2 px4">
      {isIconShown && <PermitFieldIcon fieldName={field.type} />}
      <span className="text-ellipsis tw:flex-1" title={caption}>
        {caption}
      </span>
    </div>
  )
}
